import { AppBar, Box, Toolbar, Typography, Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { DELTA_PRIMARY } from "../colors";
import logo from "../../deltagain-logo.jpg";
import { useAuth } from "../../auth/AuthContext";
import { AccountMenu } from "./AccountMenu";

export const Header = () => {
  const auth = useAuth();

  return (
    <AppBar
      position="static"
      elevation={0}
      style={{ backgroundColor: DELTA_PRIMARY }}
    >
      <Toolbar style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
        <RouterLink
          to="/"
          style={{
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
            color: "white",
            minWidth: 0,
          }}
        >
          <Box
            component="img"
            src={logo}
            alt="DeltaGain"
            style={{
              width: 36,
              height: 36,
              borderRadius: 8,
              marginRight: 12,
              flexShrink: 0,
            }}
          />
          <Typography
            variant="h6"
            noWrap
            sx={{
              fontFamily: "'Poppins', sans-serif",
              color: "white",
              fontSize: { xs: 16, sm: 20 },
            }}
          >
            Company Directory
          </Typography>
        </RouterLink>

        <Box style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
          <Button component={RouterLink} to="/" style={{ color: "white", minWidth: "auto" }}>
            Home
          </Button>
          <Button component={RouterLink} to="/api-docs" style={{ color: "white", minWidth: "auto" }}>
            API
          </Button>
          {auth.status === "signedIn" ? (
            <>
              <Button component={RouterLink} to="/portfolio" style={{ color: "white", minWidth: "auto" }}>
                {auth.isEnterprise ? "My Portfolios" : "Favourites"}
              </Button>
              <AccountMenu email={auth.email} onSignOut={auth.signOut} />
            </>
          ) : (
            <Button component={RouterLink} to="/login" style={{ color: "white", minWidth: "auto" }}>
              Sign In
            </Button>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
